// Translations for Lacrea website
export const translations = {
  fr: {
    // Header
    nav: {
      services: "Services",
      pricing: "Tarifs",
      process: "Méthode",
      work: "Réalisations",
      about: "À propos",
      contact: "Contact",
      cta: "Devis gratuit",
    },
    // Hero
    hero: {
      badge: "Votre site pro, livré en un temps record",
      title1: "Nous créons",
      rotating: [
        "des expériences digitales",
        "des sites web personnalisés",
        "des blogs performants",
        "des solutions e-commerce",
        "des outils sur-mesure",
      ],
      subtitle:
        "Un studio web boutique qui transforme votre vision en sites web performants et élégants. Qualité professionnelle, prix accessibles.",
      ctaPrimary: "Demander un devis gratuit",
      ctaSecondary: "Voir nos réalisations",
      stat1: "Visibilité et clients x5",
      floatingCard: "Visibilité et clients",
      stat2: "Devis en moins de 48h",
      stat3: "À partir de",
    },
    // Services
    services: {
      label: "Ce que nous faisons",
      title1: "Des services adaptés",
      title2: "à votre croissance",
      subtitle:
        "Nous combinons expertise technique et créativité pour offrir des solutions qui aident votre entreprise à se démarquer en ligne.",
      items: [
        {
          title: "Développement Web",
          description:
            "Sites web sur mesure avec les technologies modernes. Des landing pages aux applications web complexes.",
          features: ["Design responsive", "Optimisé SEO", "Chargement rapide"],
        },
        {
          title: "Design UI/UX",
          description:
            "Interfaces belles et intuitives qui convertissent les visiteurs en clients et les fidélisent.",
          features: ["Recherche utilisateur", "Wireframing", "Prototypage"],
        },
        {
          title: "Intégration IA",
          description:
            "Exploitez l'IA pour automatiser vos processus, améliorer l'expérience utilisateur et évoluer plus vite.",
          features: ["Chatbots", "Automatisation", "Fonctionnalités intelligentes"],
        },
        {
          title: "Applications Web",
          description:
            "Applications full-stack avec backends robustes, bases de données sécurisées et expériences utilisateur fluides.",
          features: ["Tableaux de bord", "APIs", "Bases de données"],
        },
        {
          title: "E-Commerce",
          description:
            "Boutiques en ligne qui génèrent des ventes avec un checkout fluide, gestion des stocks et analytics.",
          features: ["Paiement intégré", "Inventaire", "Analytics"],
        },
        {
          title: "Maintenance & Support",
          description:
            "Support continu pour garder votre site sécurisé, à jour et performant.",
          features: ["Mises à jour sécurité", "Performance", "Support réactif"],
        },
      ],
    },
    // Pricing
    pricing: {
      label: "Tarifs transparents",
      title1: "Des formules claires,",
      title2: "sans surprise",
      subtitle:
        "Pas de devis opaque ni de frais cachés. Choisissez la formule adaptée à vos besoins et votre budget.",
      plans: [
        {
          name: "Essentiel",
          price: "800",
          unit: "€",
          description: "Idéal pour lancer votre présence en ligne",
          features: [
            "Site vitrine 1 à 5 pages",
            "Design responsive mobile",
            "Formulaire de contact",
            "Optimisation SEO de base",
            "Livraison en 1-2 semaines",
          ],
          cta: "Demander un devis",
          popular: false,
        },
        {
          name: "Professionnel",
          price: "3 000",
          unit: "€",
          description: "Pour les entreprises qui veulent se démarquer",
          features: [
            "Site sur mesure jusqu'à 15 pages",
            "Design UI/UX personnalisé",
            "Animations et interactions",
            "SEO avancé + Analytics",
            "Intégration CMS (blog, actualités)",
            "Support 3 mois inclus",
          ],
          cta: "Demander un devis",
          popular: true,
        },
        {
          name: "Sur Mesure",
          price: "8 000",
          unit: "€+",
          description: "Applications web et projets complexes",
          features: [
            "Application web complète",
            "E-commerce / Marketplace",
            "Intégration IA et automatisation",
            "Base de données et APIs",
            "Dashboard et back-office",
            "Support 6 mois inclus",
          ],
          cta: "Discutons de votre projet",
          popular: false,
        },
      ],
      disclaimerTitle: "Ces tarifs sont purement indicatifs",
      disclaimerText: "Le prix final dépend entièrement de vos objectifs : visibilité, communication, fonctionnalités, nombre de pages, intégrations... Chaque projet est unique. Contactez-nous pour un devis 100% personnalisé et adapté à votre budget.",
    },
    // Process
    process: {
      label: "Notre méthode",
      title1: "Un processus",
      title2: "simple et efficace",
      subtitle:
        "De l'idée au lancement, nous vous accompagnons à chaque étape avec transparence et réactivité.",
      steps: [
        {
          number: "01",
          title: "Découverte",
          description:
            "On échange sur votre projet, vos objectifs et votre audience. Vous recevez un devis détaillé sous 48h.",
        },
        {
          number: "02",
          title: "Design",
          description:
            "On crée les maquettes de votre site. Vous validez le design avant qu'on ne commence le développement.",
        },
        {
          number: "03",
          title: "Développement",
          description:
            "On code votre site avec les technologies modernes. Vous suivez l'avancement en temps réel.",
        },
        {
          number: "04",
          title: "Lancement",
          description:
            "Tests, optimisations, mise en ligne. On reste disponible pour le support et les évolutions.",
        },
      ],
    },
    // Portfolio
    portfolio: {
      label: "Nos inspirations",
      title1: "Le niveau de qualité",
      title2: "que nous visons",
      subtitle:
        "Voici des sites qui illustrent notre standard de qualité. Cliquez pour les explorer en direct.",
      items: [
        {
          title: "Supabase",
          category: "Plateforme Cloud",
          description: "Design sombre et moderne pour une plateforme backend open-source de référence",
        },
        {
          title: "Astro",
          category: "Framework Web",
          description: "Landing page spectaculaire avec des animations fluides et une identité forte",
        },
        {
          title: "Cal.com",
          category: "SaaS Productivité",
          description: "Interface épurée et professionnelle pour la prise de rendez-vous en ligne",
        },
        {
          title: "Tailwind CSS",
          category: "Outil Dev",
          description: "Documentation élégante et site vitrine parfaitement structuré",
        },
      ],
    },
    // About
    about: {
      label: "À propos",
      title1: "Pourquoi travailler",
      title2: "avec nous ?",
      description:
        "Nous sommes un studio digital boutique qui combine l'approche personnalisée d'un freelance avec les capacités d'une agence. Grâce aux outils IA, nous livrons des sites de qualité professionnelle plus rapidement et à meilleur prix.",
      benefits: [
        "Communication directe avec le développeur",
        "Livraison accélérée grâce à l'IA",
        "Tarifs transparents, sans frais cachés",
        "Stack technique moderne pour de meilleures performances",
        "Support et maintenance continus",
        "Satisfaction garantie à 100%",
      ],
      experience: "ans d'expérience",
      stats: {
        delivery: "Livraison rapide",
        response: "Temps de réponse",
        guarantee: "Satisfait ou retravaillé",
      },
    },
    // Contact
    contact: {
      label: "Nous contacter",
      title1: "Demandez votre",
      title2: "devis gratuit",
      subtitle:
        "Décrivez votre projet et recevez un devis détaillé sous 48h. Sans engagement.",
      info: {
        email: "Email",
        location: "Localisation",
        locationValue: "À distance / France entière",
        response: "Temps de réponse",
        responseValue: "Sous 24-48 heures",
      },
      form: {
        name: "Nom",
        namePlaceholder: "Jean Dupont",
        email: "Email",
        emailPlaceholder: "jean@entreprise.com",
        company: "Entreprise",
        companyPlaceholder: "Votre entreprise",
        budget: "Budget estimé",
        budgetPlaceholder: "Sélectionner un budget",
        budgets: [
          { value: "800-2000", label: "800€ - 2 000€" },
          { value: "2000-5000", label: "2 000€ - 5 000€" },
          { value: "5000-10000", label: "5 000€ - 10 000€" },
          { value: "10000-20000", label: "10 000€ - 20 000€" },
        ],
        message: "Détails du projet",
        messagePlaceholder:
          "Parlez-nous de votre projet, vos objectifs et votre calendrier...",
        submit: "Envoyer ma demande de devis",
        submitting: "Envoi en cours...",
        privacy: "En soumettant, vous acceptez notre politique de confidentialité.",
        success: "Demande envoyée avec succès !",
        successDesc: "Nous vous répondrons avec un devis sous 48 heures.",
        error: "Échec de l'envoi",
        errorDesc: "Veuillez réessayer ou nous contacter directement par email.",
      },
    },
    // Footer
    footer: {
      title1: "Prêt à lancer",
      title2: "votre projet ?",
      subtitle:
        "Transformons votre vision en réalité. Contactez-nous pour une consultation et un devis gratuits.",
      cta: "Demander un devis gratuit",
      copyright: "Tous droits réservés.",
    },
  },
  en: {
    // Header
    nav: {
      services: "Services",
      pricing: "Pricing",
      process: "Process",
      work: "Work",
      about: "About",
      contact: "Contact",
      cta: "Free Quote",
    },
    // Hero
    hero: {
      badge: "Your pro website, delivered in record time",
      title1: "We craft",
      rotating: [
        "digital experiences",
        "custom websites",
        "powerful blogs",
        "e-commerce solutions",
        "tailor-made tools",
      ],
      subtitle:
        "A boutique web studio that transforms your vision into stunning, high-performance websites. Professional quality, accessible pricing.",
      ctaPrimary: "Get a Free Quote",
      ctaSecondary: "View Our Work",
      stat1: "Visibility & clients x5",
      floatingCard: "Visibility & clients",
      stat2: "Quote within 48h",
      stat3: "Starting from",
    },
    // Services
    services: {
      label: "What We Do",
      title1: "Services tailored for",
      title2: "your growth",
      subtitle:
        "We combine technical expertise with creative thinking to deliver solutions that help your business stand out and succeed online.",
      items: [
        {
          title: "Website Development",
          description:
            "Custom websites built with modern technologies. From landing pages to complex web applications.",
          features: ["Responsive Design", "SEO Optimized", "Fast Loading"],
        },
        {
          title: "UI/UX Design",
          description:
            "Beautiful, intuitive interfaces that convert visitors into customers and keep them engaged.",
          features: ["User Research", "Wireframing", "Prototyping"],
        },
        {
          title: "AI Integration",
          description:
            "Leverage cutting-edge AI to automate workflows, enhance user experience, and scale faster.",
          features: ["Chatbots", "Automation", "Smart Features"],
        },
        {
          title: "Web Applications",
          description:
            "Full-stack applications with robust backends, secure databases, and seamless user experiences.",
          features: ["Custom Dashboards", "APIs", "Databases"],
        },
        {
          title: "E-Commerce",
          description:
            "Online stores that drive sales with smooth checkout, inventory management, and analytics.",
          features: ["Payment Integration", "Inventory", "Analytics"],
        },
        {
          title: "Maintenance & Support",
          description:
            "Ongoing support to keep your website secure, updated, and performing at its best.",
          features: ["Security Updates", "Performance", "24/7 Support"],
        },
      ],
    },
    // Pricing
    pricing: {
      label: "Transparent Pricing",
      title1: "Clear plans,",
      title2: "no surprises",
      subtitle:
        "No opaque quotes or hidden fees. Choose the plan that fits your needs and budget.",
      plans: [
        {
          name: "Essential",
          price: "800",
          unit: "€",
          description: "Perfect to launch your online presence",
          features: [
            "1-5 page showcase website",
            "Mobile responsive design",
            "Contact form",
            "Basic SEO optimization",
            "Delivered in 1-2 weeks",
          ],
          cta: "Get a Quote",
          popular: false,
        },
        {
          name: "Professional",
          price: "3,000",
          unit: "€",
          description: "For businesses that want to stand out",
          features: [
            "Custom site up to 15 pages",
            "Custom UI/UX design",
            "Animations and interactions",
            "Advanced SEO + Analytics",
            "CMS integration (blog, news)",
            "3 months support included",
          ],
          cta: "Get a Quote",
          popular: true,
        },
        {
          name: "Custom",
          price: "8,000",
          unit: "€+",
          description: "Web applications and complex projects",
          features: [
            "Full web application",
            "E-commerce / Marketplace",
            "AI integration and automation",
            "Database and APIs",
            "Dashboard and back-office",
            "6 months support included",
          ],
          cta: "Let's Discuss Your Project",
          popular: false,
        },
      ],
      disclaimerTitle: "These prices are purely indicative",
      disclaimerText: "The final price depends entirely on your goals: visibility, communication, features, number of pages, integrations... Every project is unique. Contact us for a 100% personalized quote tailored to your budget.",
    },
    // Process
    process: {
      label: "Our Process",
      title1: "A simple and",
      title2: "efficient method",
      subtitle:
        "From idea to launch, we guide you every step of the way with transparency and responsiveness.",
      steps: [
        {
          number: "01",
          title: "Discovery",
          description:
            "We discuss your project, goals, and audience. You receive a detailed quote within 48 hours.",
        },
        {
          number: "02",
          title: "Design",
          description:
            "We create mockups for your site. You approve the design before development begins.",
        },
        {
          number: "03",
          title: "Development",
          description:
            "We build your site with modern technologies. You follow progress in real time.",
        },
        {
          number: "04",
          title: "Launch",
          description:
            "Testing, optimization, go live. We stay available for support and future updates.",
        },
      ],
    },
    // Portfolio
    portfolio: {
      label: "Our Inspirations",
      title1: "The quality standard",
      title2: "we aim for",
      subtitle:
        "Here are sites that illustrate our quality standard. Click to explore them live.",
      items: [
        {
          title: "Supabase",
          category: "Cloud Platform",
          description: "Dark and modern design for a leading open-source backend platform",
        },
        {
          title: "Astro",
          category: "Web Framework",
          description: "Spectacular landing page with fluid animations and strong brand identity",
        },
        {
          title: "Cal.com",
          category: "Productivity SaaS",
          description: "Clean and professional interface for online appointment scheduling",
        },
        {
          title: "Tailwind CSS",
          category: "Dev Tool",
          description: "Elegant documentation and perfectly structured showcase site",
        },
      ],
    },
    // About
    about: {
      label: "About Us",
      title1: "Why work",
      title2: "with us?",
      description:
        "We're a boutique digital studio that combines the personal touch of a freelancer with the capabilities of an agency. Using AI-powered tools, we deliver professional-grade websites faster and more affordably than traditional agencies.",
      benefits: [
        "Direct communication with the developer",
        "Faster turnaround with AI-powered workflows",
        "Transparent pricing, no hidden fees",
        "Modern tech stack for better performance",
        "Ongoing support and maintenance",
        "100% satisfaction guaranteed",
      ],
      experience: "Years of Experience",
      stats: {
        delivery: "Fast Delivery",
        response: "Avg. Response",
        guarantee: "Satisfaction guaranteed",
      },
    },
    // Contact
    contact: {
      label: "Get In Touch",
      title1: "Request your",
      title2: "free quote",
      subtitle:
        "Describe your project and receive a detailed quote within 48 hours. No commitment.",
      info: {
        email: "Email",
        location: "Location",
        locationValue: "Remote / Worldwide",
        response: "Response Time",
        responseValue: "Within 24-48 hours",
      },
      form: {
        name: "Name",
        namePlaceholder: "John Doe",
        email: "Email",
        emailPlaceholder: "john@company.com",
        company: "Company",
        companyPlaceholder: "Your company",
        budget: "Budget Range",
        budgetPlaceholder: "Select budget",
        budgets: [
          { value: "800-2000", label: "€800 - €2,000" },
          { value: "2000-5000", label: "€2,000 - €5,000" },
          { value: "5000-10000", label: "€5,000 - €10,000" },
          { value: "10000-20000", label: "€10,000 - €20,000" },
        ],
        message: "Project Details",
        messagePlaceholder:
          "Tell us about your project, goals, and timeline...",
        submit: "Request a Free Quote",
        submitting: "Sending...",
        privacy: "By submitting, you agree to our privacy policy.",
        success: "Request sent successfully!",
        successDesc: "We'll get back to you with a quote within 48 hours.",
        error: "Failed to send message",
        errorDesc: "Please try again or email us directly.",
      },
    },
    // Footer
    footer: {
      title1: "Ready to start",
      title2: "your project?",
      subtitle:
        "Let's turn your vision into a reality. Get in touch today for a free consultation and quote.",
      cta: "Get a Free Quote",
      copyright: "All rights reserved.",
    },
  },
  es: {
    // Header
    nav: {
      services: "Servicios",
      pricing: "Tarifas",
      process: "Método",
      work: "Proyectos",
      about: "Nosotros",
      contact: "Contacto",
      cta: "Presupuesto gratis",
    },
    // Hero
    hero: {
      badge: "Tu sitio web pro, entregado en tiempo récord",
      title1: "Creamos",
      rotating: [
        "experiencias digitales",
        "sitios web personalizados",
        "blogs potentes",
        "soluciones e-commerce",
        "herramientas a medida",
      ],
      subtitle:
        "Un estudio web boutique que transforma tu visión en sitios web impresionantes y de alto rendimiento. Calidad profesional, precios accesibles.",
      ctaPrimary: "Solicitar presupuesto gratis",
      ctaSecondary: "Ver nuestro trabajo",
      stat1: "Visibilidad y clientes x5",
      floatingCard: "Visibilidad y clientes",
      stat2: "Presupuesto en menos de 48h",
      stat3: "Desde",
    },
    // Services
    services: {
      label: "Lo que hacemos",
      title1: "Servicios adaptados",
      title2: "a tu crecimiento",
      subtitle:
        "Combinamos experiencia técnica con pensamiento creativo para ofrecer soluciones que ayudan a tu negocio a destacar en línea.",
      items: [
        {
          title: "Desarrollo Web",
          description:
            "Sitios web personalizados con tecnologías modernas. Desde landing pages hasta aplicaciones web complejas.",
          features: ["Diseño responsive", "Optimizado SEO", "Carga rápida"],
        },
        {
          title: "Diseño UI/UX",
          description:
            "Interfaces hermosas e intuitivas que convierten visitantes en clientes y los mantienen comprometidos.",
          features: ["Investigación de usuarios", "Wireframing", "Prototipado"],
        },
        {
          title: "Integración de IA",
          description:
            "Aprovecha la IA para automatizar flujos de trabajo, mejorar la experiencia del usuario y escalar más rápido.",
          features: ["Chatbots", "Automatización", "Funciones inteligentes"],
        },
        {
          title: "Aplicaciones Web",
          description:
            "Aplicaciones full-stack con backends robustos, bases de datos seguras y experiencias de usuario fluidas.",
          features: ["Dashboards personalizados", "APIs", "Bases de datos"],
        },
        {
          title: "E-Commerce",
          description:
            "Tiendas en línea que impulsan ventas con checkout fluido, gestión de inventario y analytics.",
          features: ["Integración de pagos", "Inventario", "Analytics"],
        },
        {
          title: "Mantenimiento y Soporte",
          description:
            "Soporte continuo para mantener tu sitio seguro, actualizado y funcionando al máximo.",
          features: ["Actualizaciones de seguridad", "Rendimiento", "Soporte 24/7"],
        },
      ],
    },
    // Pricing
    pricing: {
      label: "Tarifas transparentes",
      title1: "Planes claros,",
      title2: "sin sorpresas",
      subtitle:
        "Sin presupuestos opacos ni tarifas ocultas. Elige el plan adaptado a tus necesidades y presupuesto.",
      plans: [
        {
          name: "Esencial",
          price: "800",
          unit: "€",
          description: "Ideal para lanzar tu presencia online",
          features: [
            "Sitio web de 1 a 5 páginas",
            "Diseño responsive móvil",
            "Formulario de contacto",
            "Optimización SEO básica",
            "Entrega en 1-2 semanas",
          ],
          cta: "Solicitar presupuesto",
          popular: false,
        },
        {
          name: "Profesional",
          price: "3.000",
          unit: "€",
          description: "Para empresas que quieren destacar",
          features: [
            "Sitio a medida hasta 15 páginas",
            "Diseño UI/UX personalizado",
            "Animaciones e interacciones",
            "SEO avanzado + Analytics",
            "Integración CMS (blog, noticias)",
            "Soporte 3 meses incluido",
          ],
          cta: "Solicitar presupuesto",
          popular: true,
        },
        {
          name: "A Medida",
          price: "8.000",
          unit: "€+",
          description: "Aplicaciones web y proyectos complejos",
          features: [
            "Aplicación web completa",
            "E-commerce / Marketplace",
            "Integración IA y automatización",
            "Base de datos y APIs",
            "Dashboard y back-office",
            "Soporte 6 meses incluido",
          ],
          cta: "Hablemos de tu proyecto",
          popular: false,
        },
      ],
      disclaimerTitle: "Estos precios son puramente indicativos",
      disclaimerText: "El precio final depende completamente de tus objetivos: visibilidad, comunicación, funcionalidades, número de páginas, integraciones... Cada proyecto es único. Contáctanos para un presupuesto 100% personalizado y adaptado a tu presupuesto.",
    },
    // Process
    process: {
      label: "Nuestro método",
      title1: "Un proceso",
      title2: "simple y eficaz",
      subtitle:
        "Desde la idea hasta el lanzamiento, te acompañamos en cada paso con transparencia y rapidez.",
      steps: [
        {
          number: "01",
          title: "Descubrimiento",
          description:
            "Hablamos sobre tu proyecto, objetivos y audiencia. Recibes un presupuesto detallado en 48h.",
        },
        {
          number: "02",
          title: "Diseño",
          description:
            "Creamos los mockups de tu sitio. Validas el diseño antes de empezar el desarrollo.",
        },
        {
          number: "03",
          title: "Desarrollo",
          description:
            "Construimos tu sitio con tecnologías modernas. Sigues el avance en tiempo real.",
        },
        {
          number: "04",
          title: "Lanzamiento",
          description:
            "Pruebas, optimización, puesta en línea. Seguimos disponibles para soporte y mejoras.",
        },
      ],
    },
    // Portfolio
    portfolio: {
      label: "Nuestras inspiraciones",
      title1: "El estándar de calidad",
      title2: "que buscamos",
      subtitle:
        "Estos sitios ilustran nuestro estándar de calidad. Haz clic para explorarlos en vivo.",
      items: [
        {
          title: "Supabase",
          category: "Plataforma Cloud",
          description: "Diseño oscuro y moderno para una plataforma backend open-source de referencia",
        },
        {
          title: "Astro",
          category: "Framework Web",
          description: "Landing page espectacular con animaciones fluidas y una identidad de marca fuerte",
        },
        {
          title: "Cal.com",
          category: "SaaS Productividad",
          description: "Interfaz limpia y profesional para la programación de citas en línea",
        },
        {
          title: "Tailwind CSS",
          category: "Herramienta Dev",
          description: "Documentación elegante y sitio de presentación perfectamente estructurado",
        },
      ],
    },
    // About
    about: {
      label: "Sobre nosotros",
      title1: "¿Por qué trabajar",
      title2: "con nosotros?",
      description:
        "Somos un estudio digital boutique que combina el toque personal de un freelancer con las capacidades de una agencia. Usando herramientas de IA, entregamos sitios web de grado profesional más rápido y a mejor precio.",
      benefits: [
        "Comunicación directa con el desarrollador",
        "Entrega más rápida con flujos de trabajo de IA",
        "Precios transparentes, sin costos ocultos",
        "Stack tecnológico moderno para mejor rendimiento",
        "Soporte y mantenimiento continuo",
        "Satisfacción 100% garantizada",
      ],
      experience: "Años de experiencia",
      stats: {
        delivery: "Entrega rápida",
        response: "Tiempo de respuesta",
        guarantee: "Satisfacción garantizada",
      },
    },
    // Contact
    contact: {
      label: "Contáctanos",
      title1: "Solicita tu",
      title2: "presupuesto gratis",
      subtitle:
        "Describe tu proyecto y recibe un presupuesto detallado en 48 horas. Sin compromiso.",
      info: {
        email: "Email",
        location: "Ubicación",
        locationValue: "Remoto / Mundial",
        response: "Tiempo de respuesta",
        responseValue: "En 24-48 horas",
      },
      form: {
        name: "Nombre",
        namePlaceholder: "Juan García",
        email: "Email",
        emailPlaceholder: "juan@empresa.com",
        company: "Empresa",
        companyPlaceholder: "Tu empresa",
        budget: "Rango de presupuesto",
        budgetPlaceholder: "Seleccionar presupuesto",
        budgets: [
          { value: "800-2000", label: "€800 - €2.000" },
          { value: "2000-5000", label: "€2.000 - €5.000" },
          { value: "5000-10000", label: "€5.000 - €10.000" },
          { value: "10000-20000", label: "€10.000 - €20.000" },
        ],
        message: "Detalles del proyecto",
        messagePlaceholder:
          "Cuéntanos sobre tu proyecto, objetivos y cronograma...",
        submit: "Solicitar presupuesto gratis",
        submitting: "Enviando...",
        privacy: "Al enviar, aceptas nuestra política de privacidad.",
        success: "¡Solicitud enviada con éxito!",
        successDesc: "Te responderemos con un presupuesto en 48 horas.",
        error: "Error al enviar el mensaje",
        errorDesc: "Por favor intenta de nuevo o escríbenos directamente.",
      },
    },
    // Footer
    footer: {
      title1: "¿Listo para iniciar",
      title2: "tu proyecto?",
      subtitle:
        "Convirtamos tu visión en realidad. Contáctanos hoy para una consulta y presupuesto gratuito.",
      cta: "Solicitar presupuesto gratis",
      copyright: "Todos los derechos reservados.",
    },
  },
};

export const languages = [
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "es", name: "Español", flag: "🇪🇸" },
];
